export default function (theme) {
    return {
        MuiSwitch: {
            root: {
                color: theme.palette.primary.main
            },
            colorSecondary: {
                '&$checked': {
                    color: theme.palette.secondary.dark,
                    // '& + $bar': {
                    //     backgroundColor: theme.palette.secondary.dark
                    // }
                },                
            },
        }
    };
}